import styled from 'styled-components'

const WidthContainer = styled.section`
  max-width: 114rem;
  margin: 0 auto;
`
export default WidthContainer